// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    width: 100%;
    background: #ffffff;
    margin-top: 95px;
    border-top: 1.5px solid #e9e9e9;
}

.footer-content {
    margin: 0 auto;
}

.footer-content .footer-top,
.footer-content .footer-bottom {
    display: flex;
    justify-content: center;
}

.footer-content .footer-top {
    padding: 24px 0;
}

.footer-content .footer-bottom {
    padding: 44px 0;
    border: 1.5px solid #EAEAEA;
}

.footer-nav {
    list-style: none;
    max-width: 1280px;
    width: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.footer-nav li {
    position: relative;
}

.footer-nav li:not(:has(img))::after {
    content: "";
    width: 6px;
    height: 6px;
    background-color: var(--color-primary-red);
    border-radius: 100%;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: bottom ease-in 0.1s, opacity ease-in 0.3s;
}

.footer-nav li:hover::after {
    bottom: 2px;
    opacity: 1;
}

.footer-link {
    padding: 8px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.termos-de-uso {
    color: var(--color-contrast-dark-gray);
    font-family: ShellBook, var(--default-font-family);
    font-size: 18px;
}

.open-new-window {
    width: 16px;
    height: 16px;
    background: url(https://codia-f2c.s3.us-west-1.amazonaws.com/image/2025-04-30/L96yehEKBy.png) no-repeat center;
    background-size: cover;
    margin-top: 3px;
}

.footer-legal {
    max-width: 1280px;
    width: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.footer-brand {
    display: flex;
    align-items: center;
    gap: 12px;
}

.icon-shell {
    position: relative;
    width: 31px;
    height: 29px;
}

.icone-shell {
    position: relative;
    width: 30.503px;
    height: 28.969px;
    margin: 0;
    background: url(https://codia-f2c.s3.us-west-1.amazonaws.com/image/2025-04-30/Ks21BipWGC.png) no-repeat center;
    background-size: 100% 100%;
}

.copyright {
    color: #58595b;
}

.promocoes-validas {
    width: 580px;
    color: #4a4a4a;
}

.promo-link {
    color: #4a4a4a;
    font-family: ShellMedium, var(--default-font-family);
    font-size: 10px;
    line-height: 13px;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .footer-content .footer-top {
        padding: 40px 4px;
    }
    
    .footer-content .footer-bottom {
        padding: 32px 4px;
    }

    .footer-nav {
        flex-direction: column;
        align-items: center;
        gap: 40px;
    }

    .footer-legal {
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }

    .footer-brand {
        flex-direction: column;
        justify-content: center;
        gap: 24px;
    }

    .promocoes-validas {
        width: 100%;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,sCAAsC;IACtC,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8GAA8G;IAC9G,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,8GAA8G;IAC9G,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oDAAoD;IACpD,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[".footer {\n    width: 100%;\n    background: #ffffff;\n    margin-top: 95px;\n    border-top: 1.5px solid #e9e9e9;\n}\n\n.footer-content {\n    margin: 0 auto;\n}\n\n.footer-content .footer-top,\n.footer-content .footer-bottom {\n    display: flex;\n    justify-content: center;\n}\n\n.footer-content .footer-top {\n    padding: 24px 0;\n}\n\n.footer-content .footer-bottom {\n    padding: 44px 0;\n    border: 1.5px solid #EAEAEA;\n}\n\n.footer-nav {\n    list-style: none;\n    max-width: 1280px;\n    width: 100%;\n    padding: 0 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.footer-nav li {\n    position: relative;\n}\n\n.footer-nav li:not(:has(img))::after {\n    content: \"\";\n    width: 6px;\n    height: 6px;\n    background-color: var(--color-primary-red);\n    border-radius: 100%;\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: bottom ease-in 0.1s, opacity ease-in 0.3s;\n}\n\n.footer-nav li:hover::after {\n    bottom: 2px;\n    opacity: 1;\n}\n\n.footer-link {\n    padding: 8px 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.termos-de-uso {\n    color: var(--color-contrast-dark-gray);\n    font-family: ShellBook, var(--default-font-family);\n    font-size: 18px;\n}\n\n.open-new-window {\n    width: 16px;\n    height: 16px;\n    background: url(https://codia-f2c.s3.us-west-1.amazonaws.com/image/2025-04-30/L96yehEKBy.png) no-repeat center;\n    background-size: cover;\n    margin-top: 3px;\n}\n\n.footer-legal {\n    max-width: 1280px;\n    width: 100%;\n    padding: 0 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.footer-brand {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.icon-shell {\n    position: relative;\n    width: 31px;\n    height: 29px;\n}\n\n.icone-shell {\n    position: relative;\n    width: 30.503px;\n    height: 28.969px;\n    margin: 0;\n    background: url(https://codia-f2c.s3.us-west-1.amazonaws.com/image/2025-04-30/Ks21BipWGC.png) no-repeat center;\n    background-size: 100% 100%;\n}\n\n.copyright {\n    color: #58595b;\n}\n\n.promocoes-validas {\n    width: 580px;\n    color: #4a4a4a;\n}\n\n.promo-link {\n    color: #4a4a4a;\n    font-family: ShellMedium, var(--default-font-family);\n    font-size: 10px;\n    line-height: 13px;\n    text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n    .footer-content .footer-top {\n        padding: 40px 4px;\n    }\n    \n    .footer-content .footer-bottom {\n        padding: 32px 4px;\n    }\n\n    .footer-nav {\n        flex-direction: column;\n        align-items: center;\n        gap: 40px;\n    }\n\n    .footer-legal {\n        flex-direction: column;\n        align-items: center;\n        gap: 24px;\n    }\n\n    .footer-brand {\n        flex-direction: column;\n        justify-content: center;\n        gap: 24px;\n    }\n\n    .promocoes-validas {\n        width: 100%;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
